import React, { useState } from "react";
import DropdownUser from "../../components/DropdownUser";
import Menu from "./menu";

const UserHeader = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') as string);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };


  return (
    <nav className="bg-white shadow-[0_0px_10px_0px_rgba(0,0,0,0.3)] p-3 absolute w-full z-10 border-b border-[rgba(255, 255, 255,0.3)]">
      <div className="container mx-auto flex items-center justify-between">
        <div>
          <a href="/">
            <img
              src="./images/bluelogo.png"
              alt="Logo"
              className="h-16"
            />
          </a>
        </div>  

        {/* Container for Login Button and Menu for Desktop */}
        <div className="hidden md:flex items-center space-x-10">
           {/* Add your navigation links here */}
           <Menu />
          
          {/* Login Button for Desktop */}
          { isLoggedIn ? (
            <div className="border-l-2 pl-8  border-[#E4E4E4]">
              <DropdownUser />
              </div>
           ) : (
            <a
            href="login"
            className="text-white bg-[#037897] px-8 uppercase font-semibold rounded-lg py-3 pl-7"
          >
           <svg width="15" height="18" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline" >
<circle cx="8.57897" cy="5.77803" r="4.77803" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.00002 17.2013C0.998732 16.8654 1.07385 16.5336 1.2197 16.2311C1.67736 15.3157 2.96798 14.8306 4.03892 14.6109C4.81128 14.4461 5.59431 14.336 6.38217 14.2814C7.84084 14.1533 9.30793 14.1533 10.7666 14.2814C11.5544 14.3366 12.3374 14.4467 13.1099 14.6109C14.1808 14.8306 15.4714 15.27 15.9291 16.2311C16.2224 16.8479 16.2224 17.5639 15.9291 18.1807C15.4714 19.1418 14.1808 19.5812 13.1099 19.7917C12.3384 19.9633 11.5551 20.0766 10.7666 20.1304C9.57937 20.231 8.38659 20.2494 7.19681 20.1853C6.92221 20.1853 6.65677 20.1853 6.38217 20.1304C5.59663 20.0772 4.81632 19.964 4.04807 19.7917C2.96798 19.5812 1.68652 19.1418 1.2197 18.1807C1.0746 17.8746 0.999552 17.54 1.00002 17.2013Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>{" "}            Login
          </a>
            )}
         
        </div>  

        {/* Login Button for Mobile */}
      
    

        {/* Menu Button for Mobile */}
        <div className="md:hidden">
          <button
            className="text- focus:outline-none"
            onClick={toggleMenu}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>
            
        {/* Responsive Menu */}
        <div
          className={`fixed top-0 left-0 w-full h-full bg-white z-50 transform ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out md:hidden`}
        >
          <div className="flex items-center justify-end p-8">
            <button
              className="text-gray-800 focus:outline-none"
              onClick={toggleMenu}
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          {/* Your navigation links here */}
          <div className="text-center">
              <Menu />
            {/* Login Button for Mobile */}
            { isLoggedIn ? (
          <div className="md:hidden align-middle text-center justify-center flex"><DropdownUser /></div>
              
           ) : (
            <a
            href="login"
            className="md:hidden text-white bg-[#037897] px-8 uppercase font-semibold rounded-lg py-3 pl-7"
          >
              <svg width="15" height="18" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline" >
  <circle cx="8.57897" cy="5.77803" r="4.77803" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.00002 17.2013C0.998732 16.8654 1.07385 16.5336 1.2197 16.2311C1.67736 15.3157 2.96798 14.8306 4.03892 14.6109C4.81128 14.4461 5.59431 14.336 6.38217 14.2814C7.84084 14.1533 9.30793 14.1533 10.7666 14.2814C11.5544 14.3366 12.3374 14.4467 13.1099 14.6109C14.1808 14.8306 15.4714 15.27 15.9291 16.2311C16.2224 16.8479 16.2224 17.5639 15.9291 18.1807C15.4714 19.1418 14.1808 19.5812 13.1099 19.7917C12.3384 19.9633 11.5551 20.0766 10.7666 20.1304C9.57937 20.231 8.38659 20.2494 7.19681 20.1853C6.92221 20.1853 6.65677 20.1853 6.38217 20.1304C5.59663 20.0772 4.81632 19.964 4.04807 19.7917C2.96798 19.5812 1.68652 19.1418 1.2197 18.1807C1.0746 17.8746 0.999552 17.54 1.00002 17.2013Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>{" "}
            Login 
          </a>
       )}
         
          </div>
        </div>
      </div>
    </nav>
  );
};

export default UserHeader;
